// extracted by mini-css-extract-plugin
export default {"buttonContainer":"ToddleDocNameModal__buttonContainer___XQ4_r"};